import { Directive, ElementRef, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { GlobalService } from '@commoncore/services/global.service';
import { AppEvents } from '@commoncore/utils/app-events';

@Directive({
    standalone:true,
    selector: '[appDroppable]',
})
export class DroppableDirective implements OnInit {

    timerId: any;
    classRef: any;
    universalService:any;
    directiveService:any;
    listService:any;

    @Output() filesDropped = new EventEmitter();
    movingWithinApp: boolean = false;
    movingObjectId:any;
    @HostListener('dragover', ['$event']) onDragOver(event: DragEvent) {
        if (event.preventDefault) event.preventDefault();
        if(this.universalService.chromeOS && !this.universalService.dragDropWithinApp) return;
        if(!this.universalService.folderSpecificDrag && this.universalService.allowUpload){
            this.dragOver(event)
        }else if(window.location.href.includes('/enterprise/manageusers')){
            this.entdragOver(event)
        }
    };
  
    @HostListener('dragleave', ['$event']) dragLeaveEvent(event) {
        if (event.preventDefault) event.preventDefault();
        if(this.universalService.chromeOS && !this.universalService.dragDropWithinApp) return;
        if(!this.universalService.folderSpecificDrag && this.universalService.allowUpload){
            this.dragLeave(event)
        }else if(window.location.href.includes('/enterprise/manageusers')){
            this.dragLeave(event)
        }
    };


    @HostListener('drop', ['$event']) dropEvent(event){
        if (event.preventDefault) event.preventDefault();
        if(this.universalService.chromeOS && !this.universalService.dragDropWithinApp) return;
        if(!this.universalService.folderSpecificDrag && this.universalService.allowUpload){
            this.onDrop(event)
        }else if(window.location.href.includes('/enterprise/manageusers')){
            this.entOnDrop(event)
        }
    }
    @HostListener('dragstart',['$event']) onDragStart(event){
        this.dragStart(event);
    }
    @HostListener('dragend',['$event']) onDragEnd(event){
        if(this.universalService.chromeOS && !this.universalService.dragDropWithinApp) return;
        this.dragEnd(event);
    }
    constructor(private el: ElementRef, 
        private globalService: GlobalService
    ) {
        this.setEnvObjects(this.globalService);
    }

    setEnvObjects(globalService){
        this.universalService = globalService.getUniversalServiceRef();
        this.directiveService = globalService.getDirectiveServiceRef();
        this.listService = globalService.getListServiceRef();
    }

    ngOnInit() {
        
    }

    dragStart(event){
        this.universalService.dragDropWithinApp = true;
        var drag_icon = document.createElement("div")
        drag_icon.className = "drag-icon";
        drag_icon.style.position = "absolute";
        drag_icon.style.top = "-100px";
        drag_icon.style.right = "0px";
        document.body.appendChild(drag_icon);
        event.dataTransfer.setDragImage(drag_icon, 0, 0);
        event.dataTransfer.effectAllowed = 'copy'
        this.universalService.selectedFile = this.universalService.selectedNodes[0]["FullObject"] ? this.universalService.selectedNodes[0]["FullObject"] : this.universalService.selectedNodes[0];
        this.universalService.selectedFile["objectDragName"] = this.directiveService.setDragObjectName(this.universalService.selectedFile);
    }

    dragEnd(event){
        if(this.universalService.dragDropWithinApp){
            //alert("illegal")
            this.universalService.dragDropWithinApp = false;
            this.universalService.selectedFile = null;
            $('.ag-row').removeClass('disable-row');
            $(".gridItem").removeClass("disable-row");
            $(".fileThumbnail").removeClass("disable-row");
            var checkBoxChecked = document.querySelectorAll('.grid_info');
            if(checkBoxChecked.length == 0 && !this.universalService.listView){ 
                this.listService.deSelectAll(null)
            }
            else if(this.universalService.listView){
                this.directiveService.emitMoveOpertion()
            }
            //this.removeOverlay();
        }
    }

    dragOver(event) {
        if (event.preventDefault) event.preventDefault();
        if(this.el.nativeElement.getAttribute('droppable')== 'false' || this.universalService.dragDropWithinApp) {
            var moveDiv = document.getElementById('drag-move-snack');
            var x = event.pageX,
                y = event.pageY;
            moveDiv.style.top = (y - 20) + 'px';
            moveDiv.style.left = (x - 70) + 'px';
        
            return;
        };
        event.dataTransfer.dropEffect = 'move';
        clearTimeout(this.timerId);
        this.addOverlay()
    }

    dragLeave(event) {
        var self = this;
        if (event.stopPropagation) event.stopPropagation();
        if (event.preventDefault) event.preventDefault();
        event.dataTransfer.dropEffect = 'move';   
        this.timerId = setTimeout(function() {
          event.stopPropagation();
          window.location.href.includes('/enterprise/manageusers') ? self.removeEntModalDragOverlay() : self.removeOverlay() 
        }, 300);
    }

    async onDrop(event) {
        if (event.stopPropagation) event.stopPropagation();
        if (event.preventDefault) event.preventDefault();
        if(this.universalService.allowUpload){
            if (this.el.nativeElement.getAttribute('droppable')== null){
                this.removeOverlay();
                return;
            }
        }else{
            this.removeOverlay();
            return
        }
        this.removeOverlay();
        if(this.universalService.dragDropWithinApp){
            $('.ag-row').removeClass('disable-row');
            $(".gridItem").removeClass("disable-row");
            $(".fileThumbnail").removeClass("disable-row");
            this.universalService.dragDropWithinApp = false;
            var checkBoxChecked = document.querySelectorAll('.grid_info');
            if(checkBoxChecked.length == 0){ 
                this.listService.deSelectAll(null)
            }
            return;
        }
        this.directiveService.initiateUpload(event);
    }

    removeOverlay(){
        $('.tab-wrapper').removeClass('drag-highlight');
        $('.drag-n-drop-wrap').hide();
    }

    addOverlay(){
        if(this.universalService.dragDropWithinApp){
            return;
        }
        $('.tab-wrapper').addClass('drag-highlight');
        $('.drag-n-drop-wrap').show();
    }

    removeEntModalDragOverlay(){
        let el = document.querySelector('.import-csv-body')
        el.classList.remove('drag-highlight')
    }
    addEntModalDragOverlay(){
        let el = document.querySelector('.import-csv-body')
        el.classList.add('drag-highlight')
    }
    entdragOver(event){
        event.dataTransfer.dropEffect = 'move';
        this.addEntModalDragOverlay();
    }
    entOnDrop(event){
        if (event.stopPropagation) event.stopPropagation();
        if (event.preventDefault) event.preventDefault();
        this.removeEntModalDragOverlay();
        AppEvents.startENTUpload.next({startENTUpload: true,'files' :event.dataTransfer.files});
    }
}